import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { RoadmapItem } from '@/models/RoadmapItem';
import ListCard from './ListCard';
import emptyState from '@/assets/empty_state.svg';
import './ListView.css';

interface ListViewProps {
    data: RoadmapItem[];
    onLike: (jiraId: string, isLiked: boolean) => void;
    onFollow: (jiraId: string, isFollowed: boolean) => void;
    isAuthenticated: boolean;
    selectedJiraId?: string | null;
    onFlyoutClose?: () => void;
}

const ListView: React.FC<ListViewProps> = ({
    data,
    onLike,
    onFollow,
    isAuthenticated,
    selectedJiraId,
    onFlyoutClose,
}) => {
    if (!data || data.length === 0) {
        return (
            <Box className="list-view-empty" data-testid="list-view-empty">
                <img src={emptyState} alt="No items found" className="list-view-empty-image" />
                <Typography variant="h6" className="list-view-empty-text">
                    No roadmap items found
                </Typography>
            </Box>
        );
    }

    return (
        <Box className="list-view-container" data-testid="list-view-component">
            <Stack spacing={1} className="list-view-stack">
                {data.map(item => (
                    <ListCard
                        key={item.id}
                        data={item}
                        onLike={onLike}
                        onFollow={onFollow}
                        isAuthenticated={isAuthenticated}
                        selectedJiraId={selectedJiraId}
                        onFlyoutClose={onFlyoutClose}
                    />
                ))}
            </Stack>
        </Box>
    );
};

export default ListView;
